import { gql } from '@apollo/client'

export const GET_COMPANY_STORE_OPTIONS = gql`
  query GetCompanyStoreOptions($searchTerm: String!) {
    companyStoreOptions(searchTerm: $searchTerm) {
      id
      store {
        name
      }
    }
  }
`
